import { render, staticRenderFns } from "./AuthorMediaCard.vue?vue&type=template&id=0d28b4ef&scoped=true"
import script from "./AuthorMediaCard.vue?vue&type=script&lang=js"
export * from "./AuthorMediaCard.vue?vue&type=script&lang=js"
import style0 from "./AuthorMediaCard.vue?vue&type=style&index=0&id=0d28b4ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28b4ef",
  null
  
)

export default component.exports